export function downloadUri(uri, fileName) {
  const hiddenElement = document.createElement('a');

  hiddenElement.href = uri;
  hiddenElement.download = fileName;
  document.body.appendChild(hiddenElement);
  hiddenElement.click();
  document.body.removeChild(hiddenElement);
}
